/**
 * Shared product-page drawer: open by data-drawer-open + data-template-id, close by overlay/button/Escape.
 * Content is injected from <template id="...">; optional title from .product-information-modal__title, .usage-modal__title, or .product-categories-modal__title.
 */
(function () {
  var drawer = null;
  var bodyEl = null;
  var headerTitle = null;

  function getDrawer() {
    if (!drawer) {
      drawer = document.getElementById('app-drawer-modal');
      if (drawer) {
        bodyEl = drawer.querySelector('[data-drawer-body]');
        headerTitle = drawer.querySelector('.usage-modal__header-title');
      }
    }
    return drawer;
  }

  function open(templateId) {
    var d = getDrawer();
    if (!d || !bodyEl) return;
    var template = document.getElementById(templateId);
    if (!template) return;
    bodyEl.innerHTML = '';
    bodyEl.appendChild(template.content.cloneNode(true));
    if (headerTitle) {
      var titleEl = bodyEl.querySelector('.product-information-modal__title, .usage-modal__title, .product-categories-modal__title');
      if (titleEl) {
        headerTitle.textContent = titleEl.textContent.trim();
        titleEl.remove();
      } else {
        headerTitle.textContent = '';
      }
    }
    d.removeAttribute('hidden');
    d.setAttribute('aria-hidden', 'false');
    d.setAttribute('open', '');
    setTimeout(function () {
      d.setAttribute('active', '');
      var added = false;
      var addBodyClass = function () {
        if (added) return;
        added = true;
        document.body.classList.add('modal-show');
      };
      var overlay = d.querySelector('.fixed-overlay');
      var target = overlay || d;
      target.addEventListener('transitionend', function onOpenEnd(e) {
        if (e.target !== target) return;
        target.removeEventListener('transitionend', onOpenEnd);
        addBodyClass();
      }, { once: true });
      setTimeout(addBodyClass, 450);
    }, 75);
    var closeBtn = d.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    var d = getDrawer();
    if (!d || !d.hasAttribute('open')) return;
    document.body.classList.remove('modal-show');
    d.removeAttribute('active');
    var overlay = d.querySelector('.fixed-overlay');
    function done() {
      d.removeAttribute('open');
      d.setAttribute('hidden', '');
      d.setAttribute('aria-hidden', 'true');
    }
    if (overlay) {
      overlay.addEventListener('transitionend', function onEnd() {
        overlay.removeEventListener('transitionend', onEnd);
        done();
      }, { once: true });
    } else {
      done();
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-drawer-open]');
    if (trigger) {
      var templateId = trigger.getAttribute('data-template-id');
      if (templateId) {
        e.preventDefault();
        open(templateId);
      }
      return;
    }
    if (e.target.closest('#app-drawer-modal [data-drawer-close]')) {
      e.preventDefault();
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (getDrawer() && getDrawer().hasAttribute('open')) {
        close();
      }
      return;
    }
    var trigger = e.target.closest('[data-drawer-open]');
    if (trigger && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      trigger.click();
    }
  });
})();
